export const TEXT_EDITOR_ROUTE = '/files/text-editor';

export function buildTextEditorSearch(mountId: string, relativePath: string): string {
  const params = new URLSearchParams();
  params.set('mountId', mountId);
  params.set('path', relativePath);
  return params.toString();
}

export function textEditorHref(mountId: string, relativePath: string): string {
  return `${TEXT_EDITOR_ROUTE}?${buildTextEditorSearch(mountId, relativePath)}`;
}
